import { TableBody as MUITableBody } from '@mui/material'
import { FC } from 'react'
import { TableRows } from './tableRows'
import { ITableBodyProps } from './tableTypes'

export const TableBody: FC<ITableBodyProps> = ({ containerProps, rows }) => {
  return <MUITableBody {...containerProps}>{rows && <TableRows rows={rows} />}</MUITableBody>
}
